import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-ferme-bon-sortie-negoce',
  templateUrl: './ferme-bon-sortie-negoce.component.html',
  styleUrls: ['./ferme-bon-sortie-negoce.component.scss']
})
export class FermeBonSortieNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
